import styled, { css } from 'styled-components';

export const Sublist = styled.ul(
  ({ theme }) => css`
    list-style-type: none;
    padding: ${theme.sz.s2} ${theme.sz.s0} ${theme.sz.s0} ${theme.sz.s0};
  `,
);

export const SublistItem = styled.li(
  ({ theme }) => css`
    list-style-type: none;
    padding: ${theme.sz.s2} ${theme.sz.s0};
    max-width: ${theme.sz.s68};
    border-bottom: 1px solid ${theme.co.secondary40};

    /* if there is only one link */
    &:first-of-type:last-of-type {
      border-bottom: none;
    }
  `,
);

export const SublistItemContent = styled.div(
  ({ theme }) => css`
    min-height: ${theme.sz.s12};
    display: flex;
    align-items: center;
    gap: ${theme.sz.s1};
  `,
);

export const SublistItemFlag = styled.div(
  ({ theme }) => css`
    flex-shrink: 0;
    display: flex;
    height: ${theme.sz.s8};
    width: ${theme.sz.s8};
    font-size: ${theme.sz.s8};
  `,
);

export const SublistLink = styled.a(
  ({ theme }) => css`
    color: inherit;
    ${theme.typography.paragraph.base};
    text-decoration: none;
    transition: transform 0.5s ease;

    &:hover {
      transform: translateY(-${theme.sz.s05});
    }
  `,
);
